export const MESSAGE_CONST = {
    Create: 'Thêm mới thành công',
    Edit: 'Cập nhật thành công',
    Delete: 'Xóa thành công',
    Upload: 'Upload file thành công',
    Export: 'Xuất file thành công',
    Download: 'Tải file thành công',
    LoadData: 'Có lỗi trong quá trình lấy thông tin dữ liệu. Liên hệ đến quản trị viên để xử lý.',
    Error500: 'Hệ thống bị lỗi. Vui lòng liên hệ quản trị viên để xử lý.',
    ErrorFileUpload400: 'File không hợp lệ!',
    ErrorChange: 'Không có thay đổi!',
    Login: 'Đăng nhập thành công!',
    Error400Import: 'Các trường dữ liệu trong file excel phải điền đầy đủ thông tin!',
    ChangePassword: 'Thay đổi mật khẩu thành công!'
}